import { FC } from 'react'

import { Box, Skeleton, Table, TableBody, TableContainer, useTheme } from '@mui/material'

import { Row } from './components/Row'

export const HORIZONTAL_TABLE_SKELETON_TEST_ID = 'horizontal-table-skeleton' as const
export const HORIZONTAL_TABLE_SKELETON_ROW_TEST_ID = 'horizontal-table-skeleton-row' as const
export const HORIZONTAL_TABLE_SKELETON_CELL_TEST_ID = 'horizontal-table-skeleton-cell' as const

type Props = {
  testId?: string
  columns: number
  rows: number
}

export const HorizontalTableSkeleton: FC<Props> = ({ testId, columns, rows }) => {
  const theme = useTheme()

  return (
    <Box
      data-testid={testId || HORIZONTAL_TABLE_SKELETON_TEST_ID}
      m={2}
      pb={-1}
      mb={1}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        overflowX: 'hidden',
        borderTopLeftRadius: Number(theme.shape.borderRadius) * 2
      }}
    >
      <TableContainer>
        <Table
          sx={{
            mb: 1,
            borderCollapse: 'unset',
            '& tr:last-child td': {
              borderBottom: `1px solid ${theme.palette.horizontalTable.border.color}`
            },
            '& tr:first-of-type td:last-child': {
              borderTopRightRadius: Number(theme.shape.borderRadius) * 2
            },
            '& tr:last-child td:first-of-type': {
              boxShadow: `-1px 10px ${theme.palette.background}`,
              borderBottomLeftRadius: Number(theme.shape.borderRadius) * 2
            },
            '& tr:last-child td:last-child': {
              borderBottomRightRadius: Number(theme.shape.borderRadius) * 2
            },
            '& tr:first-of-type td': {
              borderTop: `1px solid ${theme.palette.horizontalTable.border.color}`
            },
            '& tr td': {
              borderRight: `1px solid ${theme.palette.horizontalTable.border.color}`
            }
          }}
        >
          <TableBody>
            {Array.from({ length: rows }).map((_, index) => {
              return (
                <Row
                  testId={HORIZONTAL_TABLE_SKELETON_ROW_TEST_ID}
                  key={`skeleton-row-${index}`}
                  header={<Skeleton variant="text" />}
                  values={Array.from({ length: columns }).map((_, index) => (
                    <Box
                      data-testid={HORIZONTAL_TABLE_SKELETON_CELL_TEST_ID}
                      key={`skeleton-cell-${index}`}
                      m={-2}
                      p={2}
                    >
                      <Skeleton variant="text" width={200} />
                    </Box>
                  ))}
                />
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
